/**
 * Created by sung on 2017-04-20.
 */
import { NgModule } from '@angular/core';
import {CommonModule} from "@angular/common";
import { LogConvertStatusPipe } from "./";

@NgModule({
    declarations:[LogConvertStatusPipe],
    imports:[CommonModule],
    exports:[LogConvertStatusPipe]
})

export class LogConvertPipeMoudle{}


// WEBPACK FOOTER //
// ./src/app/utility/util.module.pipe.ts